import React from 'react';
import styles from './Hero.module.css';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import FileDownloadButton from '../helper/FileDownloadButton';

// scroll hareketli buton animasyon
const YourComponent = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const handleScrollToAbout = () => {
    const aboutSection = document.getElementById('about'); 
    if (aboutSection) {
      const { top } = aboutSection.getBoundingClientRect(); 
      window.scrollTo({
        top: window.scrollY + top, 
        behavior: 'smooth',
      });
    }
  };

  return (
      <div className={styles.section}>

        <section className={styles.hero} id='home'>
          <div className={styles.banner}>
            <h1>MY PERSONAL SPACE</h1>
            <h2>REACT JS. DEVELOPER</h2>
            <p>Responsive design, Clean code, Up-to-date, New technologies</p>
            
            <FileDownloadButton />
            
            <KeyboardDoubleArrowDownIcon onClick={handleScrollToAbout} className={styles.scroll} />
          </div>
        </section>
      </div>
   
  );
};

export default YourComponent;
